/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFeatureModel } from '../../models/system-feature-model';

export interface SaveSystemFeature$Params {
      body?: SystemFeatureModel
}

export function SaveSystemFeature(http: HttpClient, rootUrl: string, params?: SaveSystemFeature$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureModel>> {
  const rb = new RequestBuilder(rootUrl, SaveSystemFeature.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFeatureModel>;
    })
  );
}

SaveSystemFeature.PATH = '/api/SystemSettings/SaveSystemFeature';
